"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Normalizer = void 0;
var Normalizer = /** @class */ (function () {
    function Normalizer(prop, scale) {
        this.min = null;
        this.max = null;
        this.range = 0;
        this.invert = false;
        this.getter = typeof prop == 'function' ? prop : function (i) { return i[prop]; };
        this.scale = scale;
    }
    Object.defineProperty(Normalizer.prototype, "isSpot", {
        get: function () {
            return this.min == this.max;
        },
        enumerable: false,
        configurable: true
    });
    Normalizer.prototype.reset = function (scale) {
        this.scale = scale;
        this.min = null;
        this.max = null;
        this.range = 0;
    };
    Normalizer.prototype.updateData = function (data) {
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            var currentValue = this.getter(item);
            if (this.min === null) {
                this.min = currentValue;
                this.max = currentValue;
                continue;
            }
            if (this.min > currentValue)
                this.min = currentValue;
            if (this.max < currentValue)
                this.max = currentValue;
        }
        this.range = this.max - this.min;
    };
    Normalizer.prototype.saveMinMax = function () {
        this.dataMin = this.min;
        this.dataMax = this.max;
    };
    Normalizer.prototype.normalize = function (v) {
        var v = v - this.min;
        if (this.invert)
            return (1 - v / this.range) * this.scale;
        return (v / this.range) * this.scale;
    };
    Normalizer.prototype.toDataScale = function (v) {
        if (this.invert) {
            var top = this.normalize(this.min);
            v = top - v;
        }
        return v * this.range / this.scale + this.min;
    };
    return Normalizer;
}());
exports.Normalizer = Normalizer;
//# sourceMappingURL=Normalizer.js.map